import type { BaseReactProps, ReactNodeDef } from '@shared/node-v1.0.0'
import { getPortDef } from '@shared/port-v1.0.0'
import Comp from '../component'

export type Props = BaseReactProps & { isVisible: boolean }

export default {
	hashTag: '#pre-release',
	module: { static: Comp },
	inNode: {
		inputs: [
			getPortDef({ name: 'loaderProps', displayName: 'Loader props', group: 'Params', type: 'objectEval' }),
			getPortDef({ name: 'overlayProps', displayName: 'Overlay props', group: 'Params', type: 'objectEval' }),
			getPortDef({ name: 'transitionProps', displayName: 'Transition props', group: 'Params', type: 'objectEval' }),
			getPortDef({ name: 'isVisible', displayName: 'Visible', group: 'States', type: 'boolean', default: false }),
			getPortDef({ name: 'toggle', displayName: 'Toggle', group: 'Signals', type: 'signal' }),
			getPortDef({ name: 'show', displayName: 'Show', group: 'Signals', type: 'signal' }),
			getPortDef({ name: 'hide', displayName: 'Hide', group: 'Signals', type: 'signal' }),
		],
		outputs: [
			getPortDef({ name: 'visible', displayName: 'Visible', group: 'States', type: 'boolean' }),
			getPortDef({ name: 'shown', displayName: 'Shown', group: 'Signals', type: 'signal' }),
			getPortDef({ name: 'hid', displayName: 'Hid', group: 'Signals', type: 'signal' }),
		],
	},
} satisfies ReactNodeDef
